<template>
  <header class="basic narrow-header">
    <div class="container -narrow">
      <div class="title flex">
        <h1 class="heading -large">
          {{ headerText }}
        </h1>
        <slot />
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
   * Slot is mostly used for right aligned buttons.  EX

           <div class="heading-action">
             <button class="btn -link -material -ico-only" aria-label="Duplicate">
               <i class="material-symbols-outlined btn-ico" aria-hidden="true">file_copy</i>
               <span class="btn-txt">Duplicate</span>
             </button>
           </div>
           <div class="heading-action">
             <button class="btn -link -material -txt-only" aria-label="Duplicate">
               <i class="material-symbols-outlined btn-ico" aria-hidden="true">file_copy</i>
               <span class="btn-txt">Duplicate</span>
             </button>
           </div>
           <div class="heading-action">
             <button class="btn -link -material -ico-txt"  aria-label="Duplicate">
               <i class="material-symbols-outlined btn-ico" aria-hidden="true">file_copy</i>
               <span class="btn-txt">Duplicate</span>
             </button>
           </div>
   */

export default defineComponent({
  name: 'PageHeaderNarrow',
  props: {
    headerText: {
      type: String,
      default: '',
    },
  },
})
</script>
